import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ShieldCheck, PackageX, Wrench, Truck, MessageCircle } from "lucide-react";

const sections = [
  {
    icon: PackageX,
    title: "Produk Kustom Tidak Dapat Ditukar/Dikembalikan",
    body: "Karena setiap produk dibuat khusus (custom) berdasarkan desain dan permintaan Anda, produk yang sudah dipesan TIDAK DAPAT ditukar, dibatalkan, atau dikembalikan (non-refundable) setelah masuk proses produksi. Mohon periksa kembali desain, ejaan teks, warna, dan varian sebelum menyelesaikan pemesanan.",
  },
  {
    icon: Wrench,
    title: "Pengecualian: Kesalahan Produksi dari Pihak Kami",
    body: "Penukaran atau produksi ulang hanya berlaku apabila terdapat kesalahan produksi dari pihak kami, seperti produk cacat, salah cetak yang tidak sesuai file yang Anda kirim, atau kerusakan akibat proses produksi. Klaim wajib disertai foto/video unboxing dan disampaikan maksimal 2x24 jam sejak barang diterima.",
  },
  {
    icon: ShieldCheck,
    title: "Kualitas File & Hasil Cetak",
    body: "Hasil cetak sangat bergantung pada kualitas file yang Anda unggah. Pastikan gambar beresolusi tinggi (minimal 300 DPI). Kami tidak bertanggung jawab atas hasil cetak yang buram, pecah, atau kurang tajam yang disebabkan oleh kualitas file asli yang rendah.",
  },
  {
    icon: Truck,
    title: "Pengiriman",
    body: "Estimasi waktu pengiriman mengikuti layanan kurir yang dipilih dan berada di luar kendali kami. Keterlambatan, kerusakan, atau kehilangan yang terjadi selama proses pengiriman menjadi tanggung jawab pihak kurir. Nomor resi akan kami berikan setelah pesanan dikirim.",
  },
  {
    icon: MessageCircle,
    title: "Konfirmasi Pembayaran",
    body: "Pembayaran dilakukan melalui QRIS dan dikonfirmasi secara manual. Pesanan baru akan diproses setelah bukti transfer Anda kirimkan melalui WhatsApp dan diverifikasi oleh tim kami.",
  },
];

export default function Terms() {
  return (
    <div className="App">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="mb-10">
          <p className="text-sm text-slate-500 uppercase tracking-wider mb-1">Kebijakan</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#00133F]" data-testid="terms-title">Syarat & Ketentuan</h1>
          <p className="text-slate-600 mt-3">Mohon baca dengan saksama sebelum melakukan pemesanan di ROOFTOP PRINT.</p>
        </div>

        <div className="space-y-5">
          {sections.map((s, i) => (
            <div key={i} className="rounded-2xl border border-slate-200 bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#00133F] flex items-center justify-center shrink-0">
                  <s.icon className="w-5 h-5 text-[#F0005A]" />
                </div>
                <div>
                  <h2 className="font-heading text-lg font-semibold text-[#00133F]">{i + 1}. {s.title}</h2>
                  <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-slate-400 mt-8">
          Dengan menyelesaikan pemesanan, Anda dianggap telah membaca, memahami, dan menyetujui seluruh Syarat & Ketentuan di atas.
        </p>
      </div>
      <Footer />
    </div>
  );
}
